module.exports = __webpack_public_path__ + "img/ic-upload-file.6afcf0d6.svg";